import React, { useContext } from "react";
import { Card } from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import "../../assets/styles/pdf-preview.scss";
import { IconArrowLeft } from "../../icons/Icon";
import { COLOR_PRIMARY } from "../../constants/colors";
import { StoreContext } from "../../store/StoreContext";
import SmuPdfPreview from "../../utils/smu-pdf-preview/SmuPdfPreview";

const PdfPreview = ({ pdf }) => {
  const { setPdfForPreview } = useContext(StoreContext);

  const back = () => {
    setPdfForPreview(null);
  };


  return (
    <>
      <Card className="smu-card">
        <Card.Header className="d-flex py-4">
          <div className="d-flex align-items-center me-auto">
            <SmuBadge color="#8E59FF" />
            <span className="fs-5 ms-3 me-auto">Cátalogos</span>
          </div>
          <div className="d-flex align-items-center ms-3">
            {/* <button className="smu-generic-button btn-action px-3 py-1" onClick={() => back()}>
              <IconArrowLeft color={COLOR_PRIMARY} />
              <span className="ms-2">Volver</span>
            </button> */}
          </div>
        </Card.Header>

        <Card.Body>
          <SmuPdfPreview pdf={pdf} />
        </Card.Body>
      </Card>
    </>
  );
};

export default PdfPreview;
